// Regex tester - live match highlighting + group inspection.
import { el, input, ta, wrap } from "./ui.js";

const esc = (s) => s.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export function regex(root) {
	const s = wrap(root); s.classList.add("rv-regex");
	const pattern = input("text", { placeholder: "pattern", value: "\\b\\w+\\b" }); pattern.classList.add("rv-regex-pat");
	const flags = input("text", { placeholder: "flags", value: "g" }); flags.classList.add("rv-regex-flags");
	const testStr = ta({ placeholder: "Test string…" }); testStr.classList.add("rv-regex-test");
	testStr.value = "The quick brown fox jumps over 12 lazy dogs.";
	const highlight = el("div", "rv-regex-out");
	const info = el("div", "rv-tnote", "");
	const groups = el("div", "rv-regex-groups");

	function run() {
		groups.textContent = "";
		let re;
		try { re = new RegExp(pattern.value, flags.value.includes("g") ? flags.value : flags.value + "g"); info.textContent = ""; info.dataset.err = ""; }
		catch (e) { info.textContent = "Invalid regex: " + e.message; info.dataset.err = "1"; highlight.textContent = testStr.value; return; }
		const text = testStr.value;
		let out = "", lastIndex = 0, m, n = 0;
		re.lastIndex = 0;
		while ((m = re.exec(text)) !== null) {
			n++;
			out += esc(text.slice(lastIndex, m.index)) + '<mark class="rv-regex-hit">' + esc(m[0] || "") + "</mark>";
			lastIndex = m.index + (m[0].length || 0);
			if (m[0] === "") re.lastIndex++;
			if (n <= 50 && m.length > 1) {
				const g = el("div", "rv-regex-group");
				g.textContent = "Match " + n + ": " + m.slice(1).map((x, i) => "$" + (i + 1) + "=" + (x === undefined ? "∅" : x)).join("  ");
				groups.appendChild(g);
			}
			if (n > 5000) break;
		}
		out += esc(text.slice(lastIndex));
		highlight.innerHTML = out || esc(text);
		info.textContent = n + " match" + (n === 1 ? "" : "es");
	}
	[pattern, flags, testStr].forEach((e) => e.addEventListener("input", run));

	const top = el("div", "rv-trow"); top.append(el("span", "rv-field-label", "/"), pattern, el("span", "rv-field-label", "/"), flags);
	s.append(top, testStr, el("h2", "rv-tool-sub", "Matches"), highlight, info, groups);
	run();
}
